export default function ThreatsScoresDirective() {
  return {
    template: require('./threats-scores.html'),
    scope: {
      threatCategories: '<',
      threatOptions: '<',
      threatTypes: '=',
    },
    controller: () => { /* 'ThreatsScoresController' */ },
    controllerAs: 'threatsScoresVM',
    bindToController: true,
    replace: true,
  };
}
